import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["colorField", "nameField"];

  connect() {
    console.log("Label manager controller connected");
  }

  selectColor(event) {
    event.preventDefault();
    const color = event.target.dataset.color;
    const colorField = this.colorFieldTarget || 
                      event.target.closest('form').querySelector('input[type="color"]');
    
    if (colorField) {
      colorField.value = color;
      // Trigger change event for any listeners
      colorField.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  showEditForm(event) {
    event.preventDefault();
    const labelId = event.target.closest('[data-label-id]').dataset.labelId;
    
    const displayDiv = document.querySelector(`#label-display-${labelId}`);
    const editDiv = document.querySelector(`#label-edit-${labelId}`);
    
    if (displayDiv && editDiv) {
      displayDiv.classList.add('hidden');
      editDiv.classList.remove('hidden');
      
      // Focus on the name field
      const nameField = editDiv.querySelector('input[type="text"]');
      if (nameField) {
        nameField.focus();
        nameField.select();
      }
    }
  }

  hideEditForm(event) {
    event.preventDefault();
    const labelId = event.target.closest('[data-label-id]').dataset.labelId;
    
    const displayDiv = document.querySelector(`#label-display-${labelId}`);
    const editDiv = document.querySelector(`#label-edit-${labelId}`);
    
    if (displayDiv && editDiv) {
      displayDiv.classList.remove('hidden');
      editDiv.classList.add('hidden');
    }
  }

  handleEditSuccess(event) {
    // Hide edit form and show display on successful update
    const form = event.target;
    const editDiv = form.closest('[id^="label-edit-"]');
    
    if (editDiv) {
      const labelId = editDiv.id.replace('label-edit-', '');
      const displayDiv = document.querySelector(`#label-display-${labelId}`);
      
      if (displayDiv) {
        displayDiv.classList.remove('hidden');
        editDiv.classList.add('hidden');
      }
    }
  }

  // Preview color changes
  previewColor(event) {
    const color = event.target.value;
    const preview = event.target.closest('.group').querySelector('.color-preview');
    if (preview) {
      preview.style.backgroundColor = color;
    }
  }
}
